module.exports = __webpack_public_path__ + "static/img/icon-星图快捷回访.b1d86e3d.png";